import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { MaterialService } from './material.service';
import { SendOTPPayload, VerifyOTPPayload, OTPVerificationResponse, SendOTPExternalPayload, VerifyOTPExternalPayload } from '../model/otp.model';

/**
 * Service de gestion des codes OTP par email
 * Les erreurs sont propagées directement aux composants appelants (pas de snackbar).
 */
@Injectable()
export class OtpService extends KiwixiService {
  private readonly API_URL = `${environment.server}otp/`;

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,
  ) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  /**
   * Envoie un code OTP à l'email de l'utilisateur
   * Source: api-recurring/recurring/otp/documentation/how_to.md#POST /api/otp/request/
   */
  sendOTP(payload: SendOTPPayload): Observable<{ detail: string }> {
    const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
    return this._http.post<{ detail: string }>(
      `${this.API_URL}request/`,
      payload,
      { headers }
    );
  }

  /**
   * Vérifie un code OTP
   * Source: api-recurring/recurring/otp/documentation/how_to.md#POST /api/otp/verify/
   */
  verifyOTP(payload: VerifyOTPPayload): Observable<OTPVerificationResponse> {
    const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
    return this._http.post<OTPVerificationResponse>(
      `${this.API_URL}verify/`,
      payload,
      { headers }
    );
  }

  /**
   * Envoie un code OTP via l'API externe FlashLevel (sans auth, par token)
   * POST /api/external/v1/flashlevel/{token}/otp/request/
   */
  sendOTPExternal(token: string, payload: SendOTPExternalPayload): Observable<{ detail: string }> {
    return this._http.post<{ detail: string }>(
      `${environment.base_server}/api/external/v1/flashlevel/${token}/otp/request/`,
      payload
    );
  }

  /**
   * Vérifie un code OTP via l'API externe FlashLevel (sans auth, par token)
   * POST /api/external/v1/flashlevel/{token}/otp/verify/
   */
  verifyOTPExternal(token: string, payload: VerifyOTPExternalPayload): Observable<OTPVerificationResponse> {
    return this._http.post<OTPVerificationResponse>(
      `${environment.base_server}/api/external/v1/flashlevel/${token}/otp/verify/`,
      payload
    );
  }
}
